import { c as _c } from "react-compiler-runtime";
import { TriangleAlert } from "lucide-react";
import { Text } from "@/components/primitives";
type ErrorProps = {
  id: string;
  text: string;
  htmlFor: string;
};
export default function ErrorMessage(t0) {
  const $ = _c(8);
  const {
    id,
    text,
    htmlFor
  } = t0;
  let t1;
  if ($[0] !== htmlFor || $[1] !== id || $[2] !== text) {
    t1 = <Text component="span" htmlFor={htmlFor} id={id} text={text} tone="destructive" variant="label-sm" />;
    $[0] = htmlFor;
    $[1] = id;
    $[2] = text;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <TriangleAlert className="text-destructive h-3 w-3" stroke="currentColor" />;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== id || $[6] !== t1) {
    t3 = <div className="flex items-center gap-1" id={id} role="alert">{t1}{t2}</div>;
    $[5] = id;
    $[6] = t1;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}